<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :readonly="board.readonly" :types="['field_name']" />

    <!-- 인원투입현황 -->
    <vs-row>
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 인원투입현황</h5>
        <div class="ml-auto">
          <vs-button color="secondary" type="border" @click="onClickLoadQR"> 금일 투입 인원 불러오기 </vs-button>
          <vs-button color="secondary" class="ml-4" @click="addNewRow"> 항목추가 </vs-button>
          <vs-button color="secondary" type="border" class="ml-2" @click="deleteSelectedRows"> 선택삭제 </vs-button>
        </div>
      </vs-col>
    </vs-row>

    <div class="table-container">
      <table class="table mt-2 sticky-table">
        <colgroup>
          <col v-if="!isPrint" width="40" />
          <col width="140" class="sticky-col" />
          <col width="140"/>
          <col width="140"/>
          <col width="140"/>
          <col width="140"/>
          <col width="140"/>
        </colgroup>
        <thead>
        <tr>
          <th v-if="!isPrint"></th>
          <th class="text-center sticky-cell">성명</th>
          <th class="text-center">연락처</th>
          <th class="text-center">부서</th>
          <th class="text-center">직종</th>
          <th class="text-center">단가</th>
          <th class="text-center">비고</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in form.인원투입현황" :key="index">
          <!-- 체크박스 -->
          <td v-if="!isPrint">
            <div class="flex justify-center items-center">
              <vs-checkbox v-model="item.checked" />
            </div>
          </td>

          <!-- 성명 -->
          <td class="sticky-cell">
            <p v-if="isPrint" class="print-input">{{ item.성명 }}</p>
            <ml-input v-else class="w-full" v-model="item.성명" :readonly="item.readonly" />
          </td>

          <!-- 연락처 -->
          <td>
            <p v-if="isPrint" class="print-input">{{ item.연락처 }}</p>
            <ml-input v-else class="w-full" v-model="item.연락처" :readonly="item.readonly" />
          </td>

          <!-- 부서 -->
          <td>
            <p v-if="isPrint" class="print-input">{{ item.부서 }}</p>
            <ml-input v-else class="w-full" v-model="item.부서" :readonly="item.readonly" />
          </td>

          <!-- 직종 -->
          <td>
            <p v-if="isPrint" class="print-input">{{ item.직종 }}</p>
            <div v-else>
              <div v-if="item.readonly">
                <p v-if="isPrint" class="print-input">{{ item.직종 === '직접입력'? item.직종_직접입력 : item.직종 }}</p>
                <ml-input v-else class="w-full" :value="item.직종 === '직접입력'? item.직종_직접입력 : item.직종" :readonly="item.readonly" />
              </div>
              <div v-else>
                <vs-select class="w-full flex-1" autocomplete v-model="item.직종" :readonly="item.readonly">
                  <vs-select-item v-for="option in 직종옵션" :key="`직종_${option}`" :text="option" :value="option" />
                </vs-select>
                <ml-input v-if="item.직종 === '직접입력'" class="w-full mt-1" v-model="item.직종_직접입력" :readonly="item.readonly" />
              </div>
            </div>

          </td>

          <!-- 단가 -->
          <td>
            <p v-if="isPrint" class="print-input">{{ item.단가 }}</p>
            <ml-input v-else class="w-full" type="number" v-model="item.단가" />
          </td>

          <!-- 비고 -->
          <td>
            <p v-if="isPrint" class="print-input">{{ item.비고 }}</p>
            <ml-input v-else class="w-full" v-model="item.비고" />
          </td>
        </tr>
        <!-- 합계 행 -->
        <tr>
          <th v-if="!isPrint"></th>
          <th class="text-center font-bold sticky-cell">합 계</th>
          <th :colspan="3"></th>
          <th>
            <p v-if="isPrint" class="print-input">{{ totalAmount }}</p>
            <ml-input v-else type="number" class="w-full" v-model="totalAmount" readonly />
          </th>
          <th></th>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- 장비투입현황 -->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 장비투입현황</h5>
        <div class="ml-auto">
          <vs-button color="secondary" type="border" @click="onClickLoadQRHEquipment"> 금일 투입 장비인원 불러오기 </vs-button>
          <vs-button color="secondary" class="ml-4" @click="addNewEquipmentRow"> 항목추가 </vs-button>
          <vs-button color="secondary" type="border" class="ml-2" @click="deleteSelectedEquipmentRows"> 선택삭제 </vs-button>
        </div>
      </vs-col>
    </vs-row>

    <div class="table-container">
      <table class="table mt-2 sticky-table">
        <colgroup>
          <col v-if="!isPrint" width="40" />
          <col width="140" class="sticky-col" />
          <col width="140"/>
          <col width="140"/>
          <col width="140"/>
          <col width="140"/>
          <col width="140"/>
          <col width="140"/>
          <col width="140"/>
        </colgroup>
        <thead>
        <tr>
          <th v-if="!isPrint">
            <div class="flex justify-center items-center">

            </div>
          </th>
          <th class="text-center sticky-cell">장비명</th>
          <th class="text-center">규격</th>
          <th class="text-center">장비번호</th>
          <th class="text-center">부서</th>
          <th class="text-center">운전원</th>
          <th class="text-center">연락처</th>
          <th class="text-center">단가</th>
          <th class="text-center">비고</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in form.장비투입현황" :key="index">
          <!-- 체크박스 -->
          <td v-if="!isPrint">
            <div class="flex justify-center items-center">
              <vs-checkbox v-model="item.checked" />
            </div>
          </td>

          <!-- 장비명 -->
          <td class="sticky-cell">
            <div v-if="item.readonly">
              <p v-if="isPrint" class="print-input">{{ item.장비명 === '직접입력' ? item.장비명_직접입력 : item.장비명 }}</p>
              <ml-input v-else class="w-full" :value="item.장비명 === '직접입력' ? item.장비명_직접입력 : item.장비명" :readonly="item.readonly" />
            </div>
            <div v-else>
              <p v-if="isPrint" class="print-input">{{ item.장비명 }}</p>
              <div v-else>
                <vs-select class="w-full flex-1" autocomplete v-model="item.장비명" @change="onEquipmentNameChange(index)">
                  <vs-select-item v-for="option in 장비명옵션" :key="`장비명_${option}`" :text="option" :value="option" />
                </vs-select>
                <ml-input v-if="item.장비명 === '직접입력'" class="w-full mt-1" v-model="item.장비명_직접입력" />
              </div>
            </div>
          </td>

          <!-- 규격 -->
          <td>
            <div v-if="item.readonly">
              <p v-if="isPrint" class="print-input">{{ item.규격 === '직접입력' ? item.규격_직접입력 : item.규격 }}</p>
              <ml-input v-else class="w-full" :value="item.규격 === '직접입력' ? item.규격_직접입력 : item.규격" :readonly="item.readonly" />
            </div>
            <div v-else>
              <p v-if="isPrint" class="print-input">{{ item.규격 }}</p>
              <div v-else>
                <template v-if="item.장비명 === '직접입력'">
                  <ml-input class="w-full" v-model="item.규격_직접입력" />
                </template>
                <template v-else>
                  <vs-select class="w-full flex-1" autocomplete v-model="item.규격">
                    <vs-select-item v-for="option in 장비규격매핑[item.장비명]" :key="`규격_${option}`" :text="option" :value="option" />
                  </vs-select>
                  <ml-input v-if="item.규격 === '직접입력'" class="w-full mt-1" v-model="item.규격_직접입력" />
                </template>
              </div>
            </div>
          </td>

          <!-- 장비번호 -->
          <td>
            <p v-if="isPrint" class="print-input">{{ item.장비번호 }}</p>
            <ml-input v-else class="w-full" v-model="item.장비번호" :readonly="item.readonly"/>
          </td>

          <!-- 부서 -->
          <td>
            <p v-if="isPrint" class="print-input">{{ item.부서 }}</p>
            <ml-input v-else class="w-full" v-model="item.부서" :readonly="item.readonly"/>
          </td>

          <!-- 운전원 -->
          <td>
            <p v-if="isPrint" class="print-input">{{ item.운전원 }}</p>
            <ml-input v-else class="w-full" v-model="item.운전원" :readonly="item.readonly"/>
          </td>

          <!-- 연락처 -->
          <td>
            <p v-if="isPrint" class="print-input">{{ item.연락처 }}</p>
            <ml-input v-else class="w-full" v-model="item.연락처" :readonly="item.readonly"/>
          </td>

          <!-- 단가 -->
          <td>
            <p v-if="isPrint" class="print-input">{{ item.단가 }}</p>
            <ml-input v-else class="w-full" type="number" v-model="item.단가" />
          </td>

          <!-- 비고 -->
          <td>
            <p v-if="isPrint" class="print-input">{{ item.비고 }}</p>
            <ml-input v-else class="w-full" v-model="item.비고" />
          </td>
        </tr>
        <!-- 합계 행 -->
        <tr>
          <th v-if="!isPrint"></th>
          <th class="text-center font-bold sticky-cell">합 계</th>
          <th :colspan="5"></th>
          <th>
            <p v-if="isPrint" class="print-input">{{ totalEquipmentAmount }}</p>
            <ml-input v-else type="number" class="w-full" v-model="totalEquipmentAmount" readonly />
          </th>
          <th></th>
        </tr>
        </tbody>
      </table>
    </div>

    <popup-q-r-history
      v-model="showQRHistory"
      :search-date="header.date"
      :search-field="{
        field_id : form.stdInfo.field_id,
        field_name : form.stdInfo.field_name,
      }"
      @select="onSelectHistory"
    />

    <popup-q-r-history-equipment
      v-model="showQRHistoryEquipment"
      :search-date="header.date"
      :search-field="{
        field_id : form.stdInfo.field_id,
        field_name : form.stdInfo.field_name,
      }"
      @select="onSelectHistoryEquipment"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import {required} from "vuelidate/lib/validators";
import PopupQRHistory from "@/popup/PopupQRHistory.vue";
import PopupQRHistoryEquipment from "@/views/boards/single-page/1040/PopupQRHistoryEquipment.vue";
import HttpRequest from "@/util/HttpRequest";

export default {
  components: {
    PopupQRHistoryEquipment,
    FileUploadModule,
    FieldSelectModule,
    PopupQRHistory
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  validations: {
    form: {
      인원투입현황: {
        $each: {
          성명: { required },
        },
      },
      장비투입현황: {
        $each: {
          장비번호: { required },
        },
      },
    },
  },
  data() {
    return {
      showQRHistory: false,
      showQRHistoryEquipment: false,
      form: {
        stdInfo: {},
        fileList: [],

        인원투입현황: [],
        장비투입현황: [],

        규격옵션: [],
      },

      직종옵션: [
        '직접입력',
        '강구조물 가공원 및 건립원',
        '건설 및 광업 단순 종사원',
        '건설 및 채굴기계 운전원',
        '건설 배관공',
        '건설·광업기계 설치공',
        '건축 도장공',
        '건축 목공',
        '건축 석공',
        '경량 철골공',
        '공업 배관공',
        '공업기계 설치공',
        '광원·채석원 및 석재 절단원',
        '기타 건설 관련 기능 종사원',
        '기타 건축 마감 관련 기능 종사원',
        '기타 배관공',
        '기타 운송장비 정비공',
        '기타 전기·전자기기 설치공',
        '기타 정보 통신기기 설치공',
        '기타 채굴 및 토목 관련 종사원',
        '내선 전기공',
        '냉동·냉장·공조기 설치공',
        '농업용·기타 기계장비 설치공',
        '단열공',
        '도배공 및 유리 부착원',
        '도장공',
        '로봇 설치공',
        '물품 이동 장비 설치공',
        '미장공',
        '바닥재 시공원',
        '발전 및 배전 장치 설치공',
        '방송 관련 장비 설치공',
        '방송·통신·인터넷 케이블 설치공',
        '방수공',
        '보일러 설치공',
        '보통인부',
        '산업 전기공',
        '새시 조립 및 설치원',
        '승강기 설치공',
        '신호수',
        '외선 전기공',
        '용접공',
        '운송장비 조립공',
        '일반기계 조립공',
        '전기 및 전자설비 설치공',
        '조적공 및 석재 부설원',
        '철근공',
        '철로 설치 및 보수원',
        '콘크리트 타설공',
        '통신 관련 장비 설치공'
      ],

      장비명옵션: [
        '직접입력',
        '불도저 (무한궤도)',
        '불도저 (타이어)',
        '유압식리퍼',
        '습지불도저',
        '굴삭기 (무한궤도)',
        '굴삭기 (타이어)',
        '습지굴삭기(무한궤도)',
        '대형브레이커',
        '유압식진동콤팩터(굴삭기부착용)',
        '압쇄기(펄버라이저)',
        '트랜처',
        '로더 (무한궤도)',
        '로더 (타이어)',
        '스크레이퍼 (자주식)',
        '스크레이퍼 (피견인식)',
        '모터그레이더(일반용)',
        '모터그레이더(사리도)',
        '덤프트럭',
        '덤프트럭 자동덮개시설',
        '머캐덤롤러(자주식)',
        '탠덤롤러(자주식)',
        '탠덤롤러 (진동자주식)',
        '진동롤러(핸드가이드식)',
        '진동롤러 (자주식)',
        '타이어롤러(자주식)',
        '양족식롤러 (자주식)',
        '래머',
        '플레이트콤펙터',
        '크레인 (무한궤도)',
        '크레인 (타이어)',
        '트럭탑재형크레인',
        '고소작업차',
        '터널용고소작업차',
        '리더(고정형)',
        '리더(회전형)',
        '케이싱',
        '스킵버킷',
        '타워크레인',
        '건설용리프트(인화물용)',
        '디젤기관차',
        '경운기',
        '지게차',
        '트랙터(타이어)',
        '트럭트랙터 및 평판트레일러',
        '아스팔트 믹싱플랜트',
        '아스팔트 피니셔',
        '아스팔트 디스트리뷰터',
        '아스팔트 스프레이어',
        '현장가열 표층재생기',
        '스테이빌라이저(안정기)',
        '콘크리트피니셔 (포장용)',
        '콘크리트피니셔 (중앙분리대용)',
        '콘크리트스프레더',
        '콘크리트 조면 마무리기',
        '콘크리트롤러페이버',
        '슬러리실 기계',
        '콘크리트배치플랜트',
        '사일로',
        '콘크리트 믹서',
        '콘크리트 믹서트럭',
        '커터(콘크리트 및 아스팔트용)',
        '콘크리트 펌프차',
        '콘크리트펌프',
        '초고압펌프',
        '콘크리트 진동기',
        '크러셔(이동식)',
        '벨트 컨베이어',
        '에이프런 피더',
        '죠 크러셔',
        '롤 크러셔',
        '콘 크러셔',
        '스크린(2단식)',
        '스크린(3단식)',
        '아그리게이트빈',
        '골재세척설비',
        '파이프추진기(오거부착유압식)',
        '파이프추진기 (공압식)',
        '유압잭',
        '공기압축기 (이동식)',
        '소형브레이커(공압식)',
        '소형브레이커(전기식)',
        '드릴웨곤',
        '크롤러드릴(공기식)',
        '크롤러드릴(탑승유압식)',
        '유압식할암기',
        '노면파쇄기',
        '소형 노면파쇄기',
        '점보드릴',
        '코아드릴',
        '그라우팅믹서',
        '그라우팅 펌프',
        '디젤파일해머',
        '보링 기계',
        '오거',
        '오실레이터, 로테이터',
        '유압파워팩',
        '강연선인장기',
        '리버스서큘레이션드릴',
        '전회전식천공기',
        '진동파일 해머(전동식)',
        '진동파일해머(유압식)',
        '워터젯트',
        '유압식압입인발기',
        '유압파일해머',
        'PBD천공기(유압식)',
        '고압분사전용장비',
        '파일천공전용장비',
        '다짐말뚝전용장비',
        '자동화 믹서플랜트',
        '고성능 착정기',
        '하수관 천공기',
        '상수도관 천공기',
        '골재살포기(자주식)',
        '진공흡입준설차',
        '버킷식준설기',
        '자동세륜기',
        '물탱크(살수차)',
        '이동식 임목파쇄기',
        '부착용집게',
        '동력분무기',
        '라인 마커',
        '차선 제거기',
        '윈치(수동식)',
        '윈치(자동식)',
        '발전기',
        '용접기(교류)',
        '용접기(직류)',
        '융착기',
        '알곤 용접기',
        '절단기',
        '프라즈마 절단기',
        '건설용펌프(자흡식)',
        '수중모터펌프',
        '취부기',
        '실사출기',
        '엔진(가솔린엔진)',
        '엔진 (디젤엔진)',
        '우레탄폼 분사용기구',
        '모터',
        '모터(쉴드TBM용)',
        '레일천공기',
        '파워렌치',
        '침목천공기',
        '타이템퍼',
        '양로기',
        '모르타르 펌프',
        '모르타르 믹서',
        '양수기',
        'Power Trowel',
        '배관파이프',
        '3D GNSS 머신 가이던스(굴삭기용)',
        '3D GNSS 머신 컨트롤(MC)(굴삭기용)',
        '3D GNSS 머신 가이던스(MG)(불도저용)',
        '펌프준설선',
        '이우선(비자항)',
        '대선',
        '하천골재채취선',
      ],

      장비규격매핑: {
        '불도저 (무한궤도)': ['7ton', '10ton', '12ton', '19ton', '32ton'],
        '불도저 (타이어)': ['15ton', '28ton', '33ton'],
        '유압식리퍼': ['16ton', '19ton', '23ton', '27ton', '32ton'],
        '습지불도저': ['4ton', '13ton'],
        '굴삭기 (무한궤도)': ['0.12㎥', '0.20㎥', '0.40㎥', '0.60㎥', '0.70㎥', '0.80㎥', '1.00㎥', '1.20㎥', '2.00㎥'],
        '굴삭기 (타이어)': ['0.18㎥', '0.60㎥', '0.80㎥', '1.00㎥'],
        '습지굴삭기(무한궤도)': ['0.4㎥', '0.7㎥'],
        '대형브레이커': ['0.2㎥', '0.4㎥', '0.6㎥', '0.7㎥', '0.8㎥', '1.0㎥'],
        '유압식진동콤팩터(굴삭기부착용)': ['0.7㎥'],
        '압쇄기(펄버라이저)': ['0.8㎥', '1.0㎥'],
        '트랜처': ['3.55ton'],
        '로더 (무한궤도)': ['0.57㎥', '0.76㎥', '0.95㎥', '1.15㎥', '1.34㎥', '1.53㎥', '1.72㎥', '2.87㎥'],
        '로더 (타이어)': ['0.25㎥', '0.57㎥', '0.95㎥', '1.34㎥', '1.72㎥', '2.29㎥', '2.87㎥', '3.50㎥', '5.00㎥'],
        '스크레이퍼 (자주식)': ['5.4㎥', '11.5㎥', '16.1㎥', '20.6㎥'],
        '스크레이퍼 (피견인식)': ['5.4㎥', '9.2㎥', '10.7㎥', '16.1㎥', '20.6'],
        '모터그레이더(일반용)': ['3.6m (일반용)'],
        '모터그레이더(사리도)': ['3.6m'],
        '덤프트럭': ['2.5ton', '4.5ton', '6.0ton', '8.0ton', '10.5ton', '15.0ton', '20.0ton', '24.0ton', '32.0ton'],
        '덤프트럭 자동덮개시설': ['15ton', '20ton', '24ton'],
        '머캐덤롤러(자주식)': ['8~10ton', '10~12ton', '12~15ton'],
        '탠덤롤러(자주식)': ['5~8ton', '8~10ton', '10~14ton'],
        '탠덤롤러 (진동자주식)': ['1ton', '2ton', '4ton', '6ton', '7ton', '8ton', '13ton'],
        '진동롤러(핸드가이드식)': ['0.7ton'],
        '진동롤러 (자주식)': ['2.5ton', '4.4ton', '6.0ton', '10.0ton', '12.0ton'],
        '타이어롤러(자주식)': ['5~8ton', '8~15ton', '15~25ton'],
        '양족식롤러 (자주식)': ['11ton', '12ton', '15ton', '19ton', '25ton', '30ton', '32ton', '37ton'],
        '래머': ['80㎏'],
        '플레이트콤펙터': ['1.5ton'],
        '크레인 (무한궤도)': ['10ton(버킷용량 0.29㎥)', '15ton(버킷용량 0.38㎥)', '20ton(버킷용량 0.57㎥)', '25ton(버킷용량 0.76㎥)', '30ton(버킷용량 1.15㎥)', '35ton(버킷용량 1.33㎥)', '40ton(버킷용량 1.53㎥)', '50ton(버킷용량 1.91㎥)', '70ton(버킷용량 2.29㎥)', '80ton(버킷용량 2.68㎥)', '100ton', '150ton', '220ton', '280ton', '300ton'],
        '크레인 (타이어)': ['10ton', '15ton', '20ton', '25ton', '30ton', '35ton', '40ton', '45ton', '50ton', '60ton', '70ton', '80ton', '100ton', '130ton', '160ton', '200ton', '220ton', '250ton', '300ton'],
        '트럭탑재형크레인': ['2ton', '3ton', '5ton', '10ton', '15ton', '18ton'],
        '고소작업차': ['2ton', '3ton', '5ton'],
        '터널용고소작업차': ['0.5ton'],
        '리더(고정형)': ['24m', '31m', '36m'],
        '리더(회전형)': ['31m', '36m'],
        '케이싱': ['22m', '27m'],
        '스킵버킷': ['10㎥'],
        '타워크레인': ['50×8', '50×10', '50×12', '50×16', '50×20'],
        '건설용리프트(인화물용)': ['1ton×45m'],
        '디젤기관차': ['5ton', '7ton'],
        '경운기': ['1000㎏'],
        '지게차': ['2.0ton', '2.5ton', '3.5ton', '5.0ton', '7.5ton'],
        '트랙터(타이어)': ['1.5ton', '2.5ton', '3.5ton', '4.5ton'],
        '트럭트랙터 및 평판트레일러': ['20ton', '30ton', '40ton', '60ton'],
        '아스팔트 믹싱플랜트': ['40ton(80㎾)', '60ton(120㎾)', '80ton(160㎾)', '100ton(200㎾)', '120ton(240㎾)'],
        '아스팔트 피니셔': ['1.7m', '3.0m'],
        '아스팔트 디스트리뷰터': ['3000ℓ(800G/A)', '3800ℓ(1000G/A)', '4700ℓ(1250G/A)', '5700ℓ(1500G/A)'],
        '아스팔트 스프레이어': ['300ℓ', '400ℓ'],
        '현장가열 표층재생기': ['479㎾'],
        '스테이빌라이저(안정기)': ['1.5m(3.7㎾)', '3.6m(9.0㎾)'],
        '콘크리트피니셔 (포장용)': ['74.6㎾', '160.4㎾', '186.5㎾', '224.0㎾', '299.9㎾'],
        '콘크리트피니셔 (중앙분리대용)': ['105.9㎾'],
        '콘크리트스프레더': ['7.95m'],
        '콘크리트 조면 마무리기': ['7.95m', '12.0m'],
        '콘크리트롤러페이버': ['12.0m'],
        '슬러리실 기계': ['3.0~3.8m'],
        '콘크리트배치플랜트': ['60㎥/hr(96㎾)', '90㎥/hr(144㎾)', '120㎥/hr(160㎾)', '150㎥/hr(177㎾)', '180㎥/hr(213㎾)', '210㎥/hr(233㎾)'],
        '사일로': ['100(7.0㎾)', '150(7.0㎾)', '200(7.7㎾)', '300(7.7㎾)'],
        '콘크리트 믹서': ['0.10㎥', '0.17㎥', '0.20㎥', '0.30㎥', '0.40㎥', '0.45㎥'],
        '콘크리트 믹서트럭': ['6.0㎥', '6.0㎥(L)'],
        '커터(콘크리트 및 아스팔트용)': ['320~400㎜'],
        '콘크리트 펌프차': ['21m, 65~75㎥/hr', '28m, 65~75㎥/hr', '32m, 80~95㎥/hr', '36m, 80~95㎥/hr', '41m, 80~95㎥/hr', '43m, 80~95㎥/hr', '47m, 80~95㎥/hr', '52m, 80~95㎥/hr'],
        '콘크리트펌프': ['12~15㎥/hr(22㎾)', '20~26㎥/hr(30㎾)'],
        '초고압펌프': ['200㎏/㎠', '400㎏/㎠'],
        '콘크리트 진동기': ['0.75㎾(전기식)', '2.60㎾(엔진식)'],
        '크러셔(이동식)': ['50ton/hr, 93㎾', '100ton/hr,155㎾', '150ton/hr,260㎾', '200ton/hr,326㎾'],
        '벨트 컨베이어': ['40.64㎝×15.24m (16˝×50ft) 3.73㎾', '45.72㎝×15.24m (18˝×50ft) 5.60㎾', '60.96㎝×15.24m (24˝×50ft) 7.46㎾', '76.20㎝×15.24m (30˝×50ft)11.19㎾', '91.44㎝×15.24m (36˝×50ft)14.92㎾'],
        '에이프런 피더': ['76.20㎝×243.84㎝ (30˝×8ft)2.24㎾', '91.44㎝×243.84㎝ (30˝×8ft)3.73㎾', '91.44㎝×365.76㎝ (30˝×12ft)3.73㎾', '106.68㎝×304.86㎝ (42˝×10ft)7.46㎾', '106.68㎝×426.72㎝ (42˝×14ft)7.46㎾'],
        '죠 크러셔': ['25.40㎝×40.64㎝(10˝×16˝) 18.65㎾', '25.40㎝×50.80㎝(10˝×20˝) 22.38㎾', '25.40㎝×60.96㎝(10˝×24˝) 29.84㎾', '25.40㎝×91.44㎝(10˝×36˝) 44.76㎾', '45.72㎝×60.90㎝(18˝×24˝) 55.95㎾', '45.72㎝×91.44㎝(18˝×36˝) 82.06㎾', '50.80㎝×91.44㎝(20˝×36˝)104.44㎾', '63.50㎝×101.60㎝(25˝×40˝)111.90㎾', '76.20㎝×101.60㎝(30˝×42˝)141.74㎾', '76.20㎝×106.68㎝(30˝×42˝)141.74㎾', '106.68㎝×121.90㎝(42˝×48˝)231.26㎾'],
        '롤 크러셔': ['40.64㎝×40.64㎝(16˝×16˝) 44.76㎾', '60.96㎝×40.64㎝(24˝×16˝) 55.95㎾', '76.20㎝×45.72㎝(30˝×18˝)111.90㎾', '76.20㎝×63.50㎝(30˝×25˝)130.55㎾', '76.20㎝×76.20㎝(30˝×30˝)223.80㎾', '101.60㎝×66.04㎝(40˝×28˝)149.20㎾', '104.14㎝×76.20㎝(41˝×30˝)223.80㎾', '139.70㎝×76.20㎝(55˝×30˝)242.45㎾'],
        '콘 크러셔': ['60.96㎝(2.00ft) 22.0㎾', '91.44㎝(3.00ft) 40.5㎾', '121.92㎝(4.00ft) 55.0㎾', '125.94㎝(4.25ft) 70.0㎾'],
        '스크린(2단식)': ['91.44㎝×243.84㎝(3ft×8ft) 5.60㎾', '91.44㎝×304.80㎝(3ft×10ft) 5.60㎾', '121.91㎝×243.84㎝(4ft×8ft) 7.46㎾', '121.91㎝×304.80㎝(4ft×10ft) 7.46㎾', '121.91㎝×356.76㎝(4ft×12ft)11.19㎾', '121.91㎝×426.72㎝(4ft×14ft)11.19㎾', '152.40㎝×365.76㎝(5ft×12ft)14.92㎾', '152.40㎝×426.72㎝(5ft×14ft)18.65㎾'],
        '스크린(3단식)': ['91.44㎝×243.84㎝ (3ft×8ft) 7.46㎾', '109.73㎝×304.80㎝ (3ft×10ft) 7.46㎾', '121.90㎝×304.80㎝ (4ft×10ft)11.19㎾', '121.90㎝×365.76㎝ (4ft×12ft)14.92㎾', '121.90㎝×426.72㎝ (4ft×14ft)14.92㎾', '152.40㎝×365.76㎝ (5ft×12ft)22.38㎾', '152.40㎝×426.72㎝ (5ft×14ft)22.38㎾', '152.40㎝×487.68㎝ (5ft×16ft)29.84㎾'],
        '아그리게이트빈': ['7.65㎥(10cy), 7.46㎾', '16.06㎥(21cy),11.19㎾', '19.11㎥(25cy),14.92㎾', '22.94㎥(30cy),14.92㎾', '26.76㎥(35cy),18.65㎾', '34.41㎥(45cy),22.38㎾', '53.52㎥(70cy),29.84㎾'],
        '골재세척설비': ['15㎾(62.5㎥/hr)'],
        '파이프추진기(오거부착유압식)': ['127ton', '240ton', '300ton'],
        '파이프추진기 (공압식)': ['180~195㎜', '220~235㎜', '270~330㎜', '350~400㎜', '450~510㎜'],
        '유압잭': ['200ton', '300ton', '400ton', '500ton', '600ton'],
        '공기압축기 (이동식)': ['3.5㎥/min', '7.1㎥/min', '10.3㎥/min', '17.0㎥/min', '21.0㎥/min', '25.5㎥/min'],
        '소형브레이커(공압식)': ['1.0㎥/min', '1.3㎥/min', '1.9㎥/min', '2.7㎥/min'],
        '소형브레이커(전기식)': ['1.5㎾'],
        '드릴웨곤': ['7.4㎥/min(100㎜)'],
        '크롤러드릴(공기식)': ['15㎥/min(120㎜)', '17㎥/min(120㎜)'],
        '크롤러드릴(탑승유압식)': ['110㎾', '150㎾'],
        '유압식할암기': ['Φ80'],
        '노면파쇄기': ['1.0m', '2.0m'],
        '소형 노면파쇄기': ['0.95㎥'],
        '점보드릴': ['2붐', '3붐'],
        '코아드릴': ['15.24㎝', '25.40㎝', '40.64㎝'],
        '그라우팅믹서': ['190ℓ×2(2㎾)', '390ℓ×2(5㎾)'],
        '그라우팅 펌프': ['30~60ℓ/min (3.7㎾)', '40~125ℓ/min(7.5㎾)', '50~200ℓ/min(11.0㎾)'],
        '디젤파일해머': ['1.5ton', '2.2ton', '3.2ton', '4.0ton'],
        '보링 기계': ['40.5㎜×150m(7.46㎾)', '50.0㎜×200m(11.19㎾)', '50.0㎜×300m(11.19㎾)', '42.0㎜×400m(11.19㎾)', '66.7㎜×500m(14.92㎾)', '66.7㎜×850m(29.84㎾)', '60.0㎜×1000m(37.30㎾)'],
        '오거': ['59.68㎾', '74.60㎾', '89.52㎾', '111.90㎾', '149.20㎾'],
        '오실레이터, 로테이터': ['1000㎜', '1500㎜', '2000㎜', '2500㎜', '3000㎜'],
        '유압파워팩': ['67.14㎾'],
        '강연선인장기': ['60ton', '120ton', '250ton', '300ton'],
        '리버스서큘레이션드릴': ['1000㎜', '1500㎜', '2000㎜', '2500㎜', '3000㎜'],
        '전회전식천공기': ['1000㎜', '1500㎜', '2000㎜', '2500㎜', '3000㎜'],
        '진동파일 해머(전동식)': ['30㎾', '40㎾', '45㎾', '60㎾', '90㎾', '120㎾'],
        '진동파일해머(유압식)': ['162㎾'],
        '워터젯트': ['96㎾'],
        '유압식압입인발기': ['100~130ton'],
        '유압파일해머': ['3ton', '5ton', '7ton', '10ton', '13ton'],
        'PBD천공기(유압식)': ['147㎾(38m)', '184㎾(53m)'],
        '고압분사전용장비': ['20ton'],
        '파일천공전용장비': ['40ton', '60ton', '100ton', '120ton', '135ton', '160ton'],
        '다짐말뚝전용장비': ['100ton', '120ton'],
        '자동화 믹서플랜트': ['0.5㎥'],
        '고성능 착정기': ['335.70㎾'],
        '하수관 천공기': ['수동식'],
        '상수도관 천공기': ['수동식'],
        '골재살포기(자주식)': ['3.5m'],
        '진공흡입준설차': ['13ton', '25ton'],
        '버킷식준설기': ['7.46㎾'],
        '자동세륜기': ['2200×5150×1000', '2650×5160×1000'],
        '물탱크(살수차)': ['1800ℓ', '3800ℓ', '5500ℓ', '6500ℓ', '16000ℓ'],
        '이동식 임목파쇄기': ['93.25㎾', '354.35㎾', '402.84㎾'],
        '부착용집게': ['0.3㎥용', '0.7~0.8㎥용'],
        '동력분무기': ['4.85㎾'],
        '라인 마커': ['10㎞/hr'],
        '차선 제거기': ['4.10㎾', '6.71㎾'],
        '윈치(수동식)': ['1ton(11.19㎾)', '3ton(22.38㎾)', '5ton(37.30㎾)', '3ton(22.38㎾)', '5ton(37.30㎾)'],
        '윈치(자동식)': ['1ton(11.19㎾)', '3ton(22.38㎾)', '3ton(22.38㎾)', '5ton(37.30㎾)'],
        '발전기': ['25㎾', '50㎾', '100㎾', '125㎾', '150㎾', '200㎾', '250㎾', '350㎾', '450㎾', '500㎾', '700㎾'],
        '용접기(교류)': ['200Amp', '300Amp', '400Amp', '500Amp'],
        '용접기(직류)': ['200Amp', '300Amp', '400Amp'],
        '융착기': ['20~75㎜', '100~150㎜', '200~300㎜', '350~400㎜', '450~600㎜', '700~900㎜'],
        '알곤 용접기': ['300Amp'],
        '절단기': ['5.08~15.24㎝', '40.64㎝'],
        '프라즈마 절단기': ['100Amp'],
        '건설용펌프(자흡식)': ['50㎜(1.49㎾×10㎜)', '80㎜(3.73㎾×15㎜)', '100㎜(3.73㎾×20㎜)', '125㎜(11.19㎾×20㎜)', '150㎜(14.92㎾×20㎜)'],
        '수중모터펌프': ['80㎜', '100㎜', '150㎜'],
        '취부기': ['11.94㎾', '18.65㎾'],
        '실사출기': ['4노즐류'],
        '엔진(가솔린엔진)': ['1.87㎾', '2.24㎾', '2.98㎾', '3.36㎾', '5.22㎾', '8.95㎾'],
        '엔진 (디젤엔진)': ['3.73㎾', '5.22㎾', '6.71㎾', '11.19㎾', '13.43㎾', '14.92㎾', '26.11㎾', '52.22㎾', '74.60㎾', '111.90㎾', '149.20㎾'],
        '우레탄폼 분사용기구': ['8.1kg/min'],
        '모터': ['0.75㎾', '1.49㎾', '2.24㎾', '3.73㎾', '5.60㎾', '7.46㎾', '11.19㎾', '14.92㎾', '18.65㎾', '22.38㎾', '29.84㎾', '37.30㎾', '55.95㎾', '74.60㎾'],
        '모터(쉴드TBM용)': ['180㎾'],
        '레일천공기': ['1.49㎾'],
        '파워렌치': ['6.6㎾'],
        '침목천공기': ['2.46㎾'],
        '타이템퍼': ['3400(진동수/min)'],
        '양로기': ['11.19㎾'],
        '모르타르 펌프': ['3.73㎾', '7.46㎾', '37.00㎾'],
        '모르타르 믹서': ['0.3㎥'],
        '양수기': ['1.49㎾'],
        'Power Trowel': ['3.73㎾'],
        '배관파이프': ['Φ50-2.6m'],
        '3D GNSS 머신 가이던스(굴삭기용)': ['3D GNSS MG'],
        '3D GNSS 머신 컨트롤(MC)(굴삭기용)': ['1.0(3D GNSS MC)'],
        '3D GNSS 머신 가이던스(MG)(불도저용)': ['19Ton(3D GNSS MG)'],
        '펌프준설선': ['비항SD 224㎾', '비항SD 448㎾', '비항SD 746㎾', '비항SD 895㎾', '비항SD 1492㎾', '비항SD 1641㎾', '비항SD 2462㎾', '비항SD 2984㎾', '비항SD 3282㎾', '비항SD 4476㎾', '비항SD 5968㎾', '비항SD 8952㎾', '비항SD 14920㎾'],
        '이우선(비자항)': ['50톤대선5톤달기(11.19㎾)', '80톤대선8톤달기(14.92㎾)'],
        '대선': ['SD 50 ton', 'SD  80 ton', 'SD 100 ton', 'SD 120 ton', 'SD 150 ton', 'SD 200 ton', 'SD 300 ton', 'SD 500 ton', 'SD 700 ton', 'SD1000 ton ', 'SD1100 ton', 'SD1400 ton', 'SD1500 ton', 'SD1750 ton', 'SD2000 ton', 'SD3000 ton'],
        '하천골재채취선': ['597㎾', '746㎾','895㎾', '970㎾', '1044㎾', '1119㎾', '1194㎾'],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    onClickLoadQR() {
      if (this.header.date) {
        this.showQRHistory = true;
      } else {
        alert("스캔 일시를 선택해주세요.");
      }
    },
    onClickLoadQRHEquipment() {
      if (this.header.date) {
        this.showQRHistoryEquipment = true;
      } else {
        alert("스캔 일시를 선택해주세요.");
      }
    },
    addNewRow() {
      const uniqueId = Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      this.form.인원투입현황.push({
        id: uniqueId,
        checked: false,
        성명: '',
        연락처: '',
        부서: '',
        단가: '',
        비고: ''
      });
    },
    deleteSelectedRows() {
      this.form.인원투입현황 = this.form.인원투입현황.filter(item => !item.checked);
    },
    addNewEquipmentRow() {
      const uniqueId = Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      this.form.장비투입현황.push({
        id: uniqueId,
        checked: false,
        장비명: '',
        규격: '',
        장비번호: '',
        부서: '',
        운전원: '',
        연락처: '',
        단가: '',
        비고: ''
      });
    },
    deleteSelectedEquipmentRows() {
      this.form.장비투입현황 = this.form.장비투입현황.filter(item => !item.checked);
    },
    onEquipmentNameChange(index) {
      const selectedEquipment = this.form.장비투입현황[index].장비명;
      const equipmentOptions = this.장비규격매핑[selectedEquipment] || [];
      this.form.장비투입현황[index].규격 = equipmentOptions[0] || '';
    },

    validate() {
      this.$v.$touch();  // 모든 검증을 활성화합니다.
      if (this.$v.$invalid) {  // 전체 폼의 유효성 검사를 체크합니다.
        // 인원투입현황 항목들의 유효성 검사를 반복합니다.
        if (this.$v.form.인원투입현황.$each.$iter) {
          const keys = Object.keys(this.$v.form.인원투입현황.$each.$iter);
          for (const key of keys) {
            if (!this.$v.form.인원투입현황.$each.$iter[key].성명.required) {
              return "성명 항목을 반드시 입력해야 합니다";
            }
          }
        } else {
          console.error("검증할 항목의 배열이 존재하지 않습니다.");
          return "검증 구조에 문제가 있습니다.";
        }

        // 장비투입현황 항목들의 유효성 검사를 반복합니다.
        if (this.$v.form.장비투입현황.$each.$iter) {
          const keys = Object.keys(this.$v.form.장비투입현황.$each.$iter);
          for (const key of keys) {
            if (!this.$v.form.장비투입현황.$each.$iter[key].장비번호.required) {
              return "장비번호 항목을 반드시 입력해야 합니다";
            }
          }
        } else {
          console.error("검증할 항목의 배열이 존재하지 않습니다.");
          return "검증 구조에 문제가 있습니다.";
        }
      }
    },

    async onSelectHistory(history) {
      if (history && history.length > 0) {

        const userIds = []
        for(const item of history) {
          console.log('Selected history item:', item);
          if (item.raw && item.raw.user_id && !userIds.includes(item.raw.user_id)) {
            userIds.push(item.raw.user_id);
          }
        }

        await this.loadMemberListInfo(userIds).
        then((response) => {
          console.log('Member list loaded:', response.data);

          if (response.data && response.data.length > 0) {
            response.data.forEach(item => {
              const isDuplicate = this.form.인원투입현황.some(existingItem =>
                existingItem.userId === item.id
              );

              // 중복되지 않은 경우에만 추가
              if (!isDuplicate) {
                let 직종 = item.position || ''
                let 직종_직접입력 = ''
                if (!this.직종옵션.includes(직종)) {
                  직종 = '직접입력'
                  직종_직접입력 = item.position
                }

                this.form.인원투입현황.push({
                  id: Date.now() + '_' + Math.random().toString(36).substr(2, 9),
                  userId: item.id,
                  checked: false,
                  성명: item.name || '',
                  연락처: item.phone || item.mobile || '',
                  부서: item.company && item.company.com_name? item.company.com_name : '',
                  readonly: true,
                  직종: 직종,
                  직종_직접입력: 직종_직접입력,
                });
              }
            });
          }

        }).catch((err) => {
          console.error("Error loading member list:", err);
        });
      }
    },

    async onSelectHistoryEquipment(history) {
      console.log('Selected history for equipment:', history.length, history);
      if (history.length > 0) {
        history.forEach((item) => {
          const isDuplicate = this.form.장비투입현황.some(existingItem =>
            existingItem.userId === item.user_id
          );

          // 중복되지 않은 경우에만 추가
          if (!isDuplicate) {
            this.form.장비투입현황.push({
              id: Date.now() + '_' + Math.random().toString(36).substr(2, 9),
              userId: item.user_id,
              checked: false,
              장비명: item.장비명 || '',
              장비명_직접입력: item.장비명_직접입력 || '',
              규격: item.장비규격 || '',
              규격_직접입력: item.장비규격_직접입력 || '',
              장비번호: item.장비번호 || '',
              운전원: item.장비운전자 || '',
              연락처: item.연락처 || '',
              부서: item.부서 || '',
              단가: '',
              비고: '',
              readonly: true,
            })
          }


        })
      }
    },

    async loadMemberListInfo(userIds) {
      console.log('Loading member list for user IDs:', userIds);
      return await HttpRequest.get("/api/v1/member", {
        params: {
          projectId: this.$route.params.proj_id,
          userIds,
          page: 1,
          perPage: 10000,
        },
      })

    },
  },
  computed: {
    totalAmount() {
      return this.form.인원투입현황.reduce((sum, item) => {
        // 단가가 비어있거나 숫자가 아닌 경우 0으로 처리
        const amount = Number(item.단가) || 0;
        return sum + amount;
      }, 0);
    },
    totalEquipmentAmount() {
      return this.form.장비투입현황.reduce((sum, item) => {
        const amount = Number(item.단가) || 0;
        return sum + amount;
      }, 0);
    }
  },
};
</script>
<style lang="scss" scoped>
/* 테이블 공통 (색상, 테두리 등) */
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th {
    background: #f9f9f9;
  }

  td {
    padding: 4px;
  }

  th,
  td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    border: 1px solid #cdcdcd;
  }
}

.table-container {
  width: 100%;
  overflow-x: auto;
  position: relative;
}

.sticky-table {
  border-collapse: collapse !important;
  border-spacing: 0 !important;
}

.sticky-cell {
  position: sticky;
  left: 0;
  z-index: 2;
  background-color: inherit;
  /* 기존 오른쪽 테두리 제거 */
  border-right: none !important;

  /* 가상 요소로 오른쪽 테두리 생성 */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 1px;
    background-color: #e0e0e0;
    z-index: 3;
  }
}

thead .sticky-cell {
  background-color: #f9f9f9;
  box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.1);
}

tbody .sticky-cell {
  background-color: #ffffff;
  box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.1);
}

/* 합계 행의 고정 셀 */
tbody tr:last-child .sticky-cell {
  background-color: #f9f9f9;
}
</style>
